import { TEntityUntagged } from '@obvious.tech/constellation/Entity'

import { TEntityOverride } from 'src/types/index'
import { AlarmToPDF } from 'src/parser/shared/PDF/ReportToPdf'

const override = {
  global: {
    properties: {
      groups: {
        displayedName: 'Owners',
        type: 'groups',
      },
      author: {
        displayedName: 'Author',
        type: 'object',
        reference: {
          target: 'Passport',
          targetLabelKeyPath: 'username',
          labelKeyPath: 'userName',
          idKeyPath: 'passportId',
        },
        readOnly: true,
      },
      assignedPassportId: {
        // deprecated field, replaced with `assignedPassport`
        hidden: true,
      },
      assignedPassport: {
        displayedName: 'Assigned Passport',
        type: 'object',
        reference: {
          target: 'Passport',
          targetLabelKeyPath: 'username',
          labelKeyPath: 'userName',
          idKeyPath: 'passportId',
        },
      },
    },
  },
  create: {
    hidden: true,
  },
  edit: {
    displayedComponent: AlarmToPDF,
  },
} satisfies TEntityOverride<TEntityUntagged<'Alarm'>>

export default override
